<template>
  <v-sheet id="cropper-wrap">
    <v-row no-gutters>
      <v-col cols="12"
             sm="9" md="9"
             lg="9" xl="9"
      >
        <cropper ref="cropper"
                 :src="computedImage.src"
                 :debounce="computedCropperOptions.debounce"
                 :stencil-component="computedCropperOptions.component"
                 :stencil-props="{
                   aspectRatio: computedCropperOptions.aspectRatio,
                 }"
                 :min-width="computedCropperOptions.minWidth"
                 :canvas="{
                   width: computedCropperOptions.width,
                 }"
                 @change="changePreview"
        />
      </v-col>
      <v-col cols="12"
             sm="3" md="3"
             lg="3" xl="3"
      >
        <v-sheet class="d-flex justify-center">
          <preview v-if="result.image"
                   :class="computedPreviewClass"
                   :width="computedPreviewOptions.width"
                   :height="computedPreviewOptions.height"
                   :image="result.image"
                   :coordinates="result.coordinates"
          />
        </v-sheet>
      </v-col>
    </v-row>


    <v-file-input ref="file" accept="image/*"
                  label="이미지 선택"
                  @change="loadImage($event)"
    />
  </v-sheet>
</template>

<script>
import { mergeDeep } from 'vuetify/lib/util/helpers'
import { Cropper, Preview } from 'vue-advanced-cropper'

export default {
  name: 'VueAdvancedCropper',
  components: {
    Cropper, Preview,
  },
  props: {
    cropperOptions: { type: Object, default: () => ({}) },
    previewOptions: { type: Object, default: () => ({}) },
  },
  data: () => ({
    image: {
      src: null,
      type: null,
    },
    result: {
      coordinates: null,
      image: null,
    },
  }),
  computed: {
    computedImage () {
      return this.image
    },
    computedCropperOptions () {
      let options = {
        component: 'rectangle-stencil',
        debounce: false,
        aspectRatio: 16 / 9,
        minWidth: null,  // crop 대상(원본)의 선택가능한 최소 너비
        width: null,  // crop 된 이미지(thumbnail)의 너비 resizing
      }

      options = mergeDeep(options, this.cropperOptions)

      return options
    },
    computedPreviewOptions () {
      let options = {
        width: 160,
        height: 90,
      }

      options = mergeDeep(options, this.previewOptions)

      return options
    },
    computedPreviewClass () {
      return { 'circle-preview': this.computedCropperOptions.component === 'circle-stencil' }
    },
  },
  destroyed () {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src)
    }
  },
  methods: {
    getMimeType (file, fallback = null) {
      const byteArray = (new Uint8Array(file)).subarray(0, 4)
      let header = ''
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16)
      }
      switch (header) {
        case '89504e47':
          return 'image/png'
        case '47494638':
          return 'image/gif'
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
          return 'image/jpeg'
        default:
          return fallback
      }
    },
    crop () {
      const { canvas } = this.$refs.cropper.getResult()
      this.$emit('cropped-image', (canvas && canvas.toDataURL()) || null)
    },
    reset () {
      this.image = {
        src: null,
        type: null,
      }
      this.result = {
        coordinates: null,
        image: null,
      }
    },
    loadImage (event) {
      // Ensure that you have a file before attempting to read it
      if (event && event.name) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src)
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(event)

        // Create a new FileReader to read this image binary data
        const reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: this.getMimeType(e.target.result, event.type),
          }
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(event)
      } else {
        this.reset()
      }

      this.$emit('cropper-image-changed')
    },
    changePreview ({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      }
    },
  },
}
</script>

<style lang="scss">
@import 'vue-advanced-cropper/dist/style.css';

#cropper-wrap {
  .circle-preview {
    border-radius: 50%;
  }
}

</style>
